import * as types from '../../../actions';

const initialState = {
    items: [],
    status:0,
    item:{
        id:'',
        name:''
    },
    activity:'',
    count:'',
    errorData:''    
};
export default function(state = initialState, action) {
    const response = action.response;
    switch(action.type) {
        case types.SECTOR_LIST_SUPERADMIN_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    items: response.data,
                    status: response.status,
                    activity:types.SECTOR_LIST_SUPERADMIN_SUCCESS,   
                    count:response.data.length              
                };
            }else{
                return {
                    ...state,
                    status: response.status,   
                    activity:types.SECTOR_LIST_SUPERADMIN_ERROR,                              
                };
            }

        case types.SECTOR_ADD_SUPERADMIN_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    items: [...state.items],
                    status: response.status,
                    activity:types.SECTOR_ADD_SUPERADMIN_SUCCESS,
                }
            }else{
                return {
                    ...state,                  
                    status: response.status,
                    activity:types.SECTOR_ADD_SUPERADMIN_ERROR,
                    errorData: response.data,         
                }    
            }
        
        case types.SECTOR_EDIT_SUPERADMIN_SUCCESS: 
            if(response.status===200){           
                return {
                    ...state,
                    item:{
                        id:response.data.id,
                        name: response.data.name
                    },
                    status: response.status,
                    activity:types.SECTOR_EDIT_SUPERADMIN_SUCCESS,               
                }
            }else{
                return { 
                    ...state, 
                    status: response.status,
                    activity:types.SECTOR_EDIT_SUPERADMIN_ERROR, 
                };

            }       

        case types.SECTOR_UPDATE_SUPERADMIN_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    items:state.items.map(item => {
                        return item.id === response.data.id ? response.data : item;
                    }),
                    status: response.status,
                    activity:types.SECTOR_UPDATE_SUPERADMIN_SUCCESS,         
                }   
            }else{
                return {
                    ...state,                  
                    status: response.status,
                    activity:types.SECTOR_UPDATE_SUPERADMIN_ERROR,
                    errorData: response.data,         
                }    
            }             

        case types.SECTOR_DELETE_SUPERADMIN_SUCCESS:
            const id = response.data.id;      
            if(response.status===200){          
                return {
                    ...state,
                    items: state.items.filter(items => items.id !== id),                
                    status: response.status,
                    activity:types.SECTOR_DELETE_SUPERADMIN_SUCCESS,   
                }
            }else{
                return {
                    ...state,
                    status: response.status,
                    activity:types.SECTOR_DELETE_SUPERADMIN_ERROR,   
                    errorData: response.data,
                }   
            }
       
        case types.CLEAR:
            return {
                ...state,
                item:{
                    id:'',
                    name:'',
                },
                activity:'',
                status:0                
            }  

        default:
            return state;
    }
  };